/* eslint-disable no-mixed-spaces-and-tabs */
import { ACTIVITY_REPORTS_LIST, ACTIVITY_REPORTS_ERROR, ACTIVITY_REPORTS_SUCCESS, ACTIVITY_REPORTS_UPDATE, ACTIVITY_REPORTS_DETAILS, ACTIVITY_REPORTS_UPDATE_ERROR, ACTIVITY_REPORTS_UPDATE_SUCCESS } from './constants';

export default function activitydata(state, action) {

	switch (action.type) {
	  
	case ACTIVITY_REPORTS_LIST:
		return { ...state, pending: true };
	case ACTIVITY_REPORTS_SUCCESS:
		return { ...state, grade_data: action.payload, pending: false };
	case ACTIVITY_REPORTS_DETAILS:
		return { ...state, details: action.payload, pending: false };
	case ACTIVITY_REPORTS_ERROR:
		return { ...state, error: true, pending: false };

	case ACTIVITY_REPORTS_UPDATE:
		return { ...state, pending: true };
	case ACTIVITY_REPORTS_UPDATE_SUCCESS:
		return { ...state, grade_update: action.payload, pending: false };
	case ACTIVITY_REPORTS_UPDATE_ERROR:
		return { ...state, error: true, pending: false };

	  
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}